module.exports = __webpack_public_path__ + "img/chicken-fall.5a345a55.gif";